var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBambusBlueLogoWithLetterB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.029 18.4592H15.7309C16.1952 18.4592 16.6596 18.3431 17.0079 17.9948C17.3562 17.6465 17.5303 17.1822 17.4723 16.7178V15.789C17.4723 15.3246 17.3562 14.8603 17.0079 14.512C16.6596 14.2217 16.1952 14.0476 15.7309 14.0476H11.029V18.4592ZM11.029 10.7969H15.0923C15.5567 10.7969 16.0211 10.6808 16.3694 10.3326C16.7177 9.98428 16.8338 9.5199 16.8338 9.05552V8.24285C16.8338 7.77847 16.7177 7.31409 16.3694 6.96581C16.0211 6.67557 15.5567 6.50143 15.0923 6.50143H11.029V10.7969ZM6.9657 3.07662H16.0792C17.4142 3.01858 18.7493 3.48296 19.7361 4.41172C20.6069 5.34048 21.1293 6.61752 21.0712 7.89457C21.0712 8.53309 21.0132 9.11356 20.781 9.75209C20.6069 10.2165 20.3747 10.6228 20.0264 10.9711C19.7361 11.3194 19.3298 11.5516 18.9235 11.6677C18.4591 11.8418 18.0528 11.8998 17.5884 11.8998V12.074C18.0528 12.074 18.5752 12.1901 18.9815 12.3062C19.504 12.4803 19.9683 12.7125 20.3166 13.0608C20.723 13.4671 21.1293 13.8735 21.3615 14.3959C21.6517 15.0344 21.8259 15.731 21.7678 16.4275C21.7678 17.1241 21.6517 17.8207 21.4195 18.5173C21.1873 19.1558 20.839 19.7363 20.4327 20.2006C20.0264 20.665 19.504 21.0713 18.9235 21.3616C18.343 21.6518 17.6464 21.7679 17.0079 21.7679H6.9657V3.07662Z",
    fill: "#012A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12137 0.232422H0V7.95274H4.12137V0.232422Z",
    fill: "#012A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12137 10.7969H0V18.5172H4.12137V10.7969Z",
    fill: "#012A59"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBambusBlueLogoWithLetterB);
export default __webpack_public_path__ + "static/media/BambusBlueLogoWithLetterB.8bfab50fadbdd902872cb8f7a9e7cf95.svg";
export { ForwardRef as ReactComponent };